import { useState } from "react";
import { LogResponseArchive, SearchLogHistory } from "../../axios";
import { DbUtils } from "../../utils/DbUtils";
import { ErrorUtils } from "../../utils/ErrorUtils";
import ArchiveLogCondition from "../parts/ArchiveLogCondition";
import ArchiveLogList from "../parts/ArchiveLogList";

/**
 * ログ履歴画面用コンポーネント
 * 
 * @returns 	
 */
export default function ArchiveLogPage(): JSX.Element {

	/** 検索履歴Id */
	const [searchId, setSearchId] = useState<string | undefined>(undefined);

	const [logArchives, setLogArchives] = useState<LogResponseArchive[] | undefined>(undefined);

	/**
	 * 検索時用イベント
	 * 
	 * @param search 
	 */
	const handleSearch = async (search: SearchLogHistory) => {
		setLogArchives(undefined);
		void doSearch(search);
	};

	/**
	 * ログ検索を行う。
	 * 
	 * 
	 * @param search 
	 * @returns 
	 */
	const doSearch = async (search: SearchLogHistory) => {
		try {
			const res = await DbUtils.getArchiveApi().searchLogArchives(search);
			setLogArchives(res.data.logArchives);
			setSearchId(res.data.search_id);
		} catch (error) {
			ErrorUtils.alert(error);
		}
	};

	// 描画する
	return (
		<>
			<h4>ログ履歴</h4>

			<hr />
			<form className="form-horizontal">
				<ArchiveLogCondition onSearch={handleSearch} />
			</form>

			{searchId != undefined && logArchives != undefined &&
				<ArchiveLogList searchId={searchId} logArchives={logArchives} />
			}

		</>
	);

}